import React from 'react';

export function AdminSubscribersTab({ subscribers }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Newsletter Subscribers
        </h1>
        <span className="text-[#71717A]">{subscribers.length} subscribers</span>
      </div>
      
      <div className="bg-[#141417] border border-[#27272A] rounded-md overflow-hidden">
        <table className="data-table">
          <thead>
            <tr className="bg-[#09090B]">
              <th>Email</th>
              <th>Name</th>
              <th>Subscribed At</th>
            </tr>
          </thead>
          <tbody>
            {subscribers.map(s => (
              <tr key={s.email}>
                <td className="text-white font-mono">{s.email}</td>
                <td className="text-[#A1A1AA]">{s.name || '-'}</td>
                <td className="text-[#71717A] font-mono text-sm">
                  {new Date(s.subscribed_at).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
